import React from 'react';
import HeaderFour from '../../components/Header/HeaderFour';
import FooterTwo from '../../components/Footer/FooterTwo';
import BlogSidebarMain from './BlogSidebarMain';

import Logo from '../../assets/img/logo/sanasa-logo-white.png';

const BlogSidebar = () => {
  return (
    <>
      <HeaderFour />

      <BlogSidebarMain />

      <FooterTwo
        footerClass="it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-5 inner-style black-bg pb-70"
        footerLogo={Logo}
        btnClass="it-btn-white sky-bg"
        copyrightTextClass="it-copyright-text inner-style text-center"
      />
    </>
  );
};

export default BlogSidebar;
